export default {
  email: '',
  login: '',
  name: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  source: 'extension',
  type: 'company',
  password: '',
  invitationKey: null,
  langKey: 'en',
  activated: false,
};
